import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=32088ebe"
import script from "./YoutubePlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./YoutubePlayer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports